/* src/app/toast/toast.component.scss */
.toast-container {
  position: relative;
}
.toast-container .toastt {
  position: fixed;
  top: 16px;
  left: 288px;
  right: 0;
  height: 56px;
  font-size: 18px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #ffffff;
  line-height: 56px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  z-index: 102;
}
.toast-container .toastt.toast-active {
  transition: all 0.3s ease-in-out;
  top: 72px;
}
.toast-container .toastt a {
  color: white;
  text-decoration: underline;
}
.alert-success {
  background-color: #376e56;
}
.alert-danger {
  background-color: rgb(143, 73, 73);
}
.alert-info {
  background-color: #376e56;
}
.alert-warning {
  background-color: #e4be5e;
}
@media (max-width: 1199px) {
  .toast-container .toastt {
    left: 80px;
  }
}
/*# sourceMappingURL=toast.component.css.map */
